var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.158 14.5c0 .928.388 1.819 1.079 2.475A3.785 3.785 0 008.842 18c.977 0 1.914-.369 2.605-1.025a3.414 3.414 0 001.08-2.475c0-.928-.389-1.819-1.08-2.475C10.757 11.57 9.82 11 8.842 11c-.977 0-1.914.569-2.605 1.025A3.414 3.414 0 005.158 14.5z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.579 11v3.516L10.684 17M15.684 11h3.158M15.684 14h3.158M15.684 17h3.158",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 4h17.334S22 4 22 5.275v14.45S22 21 20.667 21H3.333S2 21 2 19.725V5.275S2 4 3.333 4zM2 8h20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDashboardChart;